"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    StorageContext: ()=>StorageContext,
    StorageProvider: ()=>StorageProvider,
    useStorage: ()=>useStorage,
    useStorageValue: ()=>useStorageValue
});
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const _usehooksTs = require("usehooks-ts");
const _ = require("..");
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
const StorageContext = /*#__PURE__*/ _react.default.createContext({});
const StorageProvider = ({ children , storage  })=>{
    return /*#__PURE__*/ _react.default.createElement(StorageContext.Provider, {
        value: storage
    }, children);
};
const useStorage = ()=>_react.default.useContext(StorageContext);
const useStorageValue = (key)=>{
    const storage = useStorage();
    const [stored, setStored] = (0, _react.useState)();
    const setValue = (0, _react.useCallback)((value)=>{
        return storage.set(key, value);
    }, [
        setStored,
        key
    ]);
    const removeValue = (0, _react.useCallback)(async ()=>{
        setStored(null);
        await storage.remove(key);
    }, [
        storage,
        setStored,
        key
    ]);
    (0, _.useOnAppEvent)('storage-set', (data)=>{
        if (data.entries) {
            const entry = data.entries.find(([k])=>k === key);
            if (entry) {
                const [, value] = entry;
                setStored(value);
            }
        }
        if (data.key && data.key === key) {
            setStored(data.value);
        }
    }, [
        key
    ]);
    (0, _.useOnAppEvent)('storage-removed', (data)=>{
        if (data.key && data.key === key) {
            setStored(null);
        }
        if (data.keys && data.keys.includes(key)) {
            setStored(null);
        }
    }, [
        key
    ]);
    (0, _usehooksTs.useEffectOnce)(()=>{
        storage && storage.get && storage.get(key).then((value)=>{
            setStored(value);
        });
    });
    return {
        value: stored,
        setValue,
        removeValue
    };
};
